<template>
  <span>
    <!-- <v-tooltip bottom>
      <v-btn slot="activator" :loading="false" small color="grey lighten-4" fab @click="openDialog" :disabled="disabled">
        <v-icon :color="shared ? 'teal' : 'black'">link</v-icon>
      </v-btn>
      <span >{{this.shared ? 'Compartilhado publicamente' : 'Compartilhar tarefa'}}</span>
    </v-tooltip> -->
    <v-dialog v-model="dialog" @keydown.enter="confirm" @keydown.esc="cancel" max-width="400" persistent scrollable>
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Use o link para compartilhar a tarefa
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout wrap justify-center align-center>
            <v-flex xs12>
              <v-tooltip top>
                <v-text-field append-icon="file_copy" slot="activator" readonly name="link" id="link" label="link" type="text" :value="link" @click="copy" @click:append="copy"  messages="Esse link já pode ser compartilhado com participantes da tarefa"/>
              <span>Clique para copiar</span>
            </v-tooltip>  
            </v-flex>
            <v-flex xs12>
              <v-switch v-model="editedItem.shared" label="Qualquer pessoa com o link pode visualizar"></v-switch>
            </v-flex>
            <v-flex v-show="editedItem.shared" xs12>
              <v-layout>
                <v-text-field slot="activator" prepend-icon="lock" name="password" label="Senha(Opcional)" id="password"
                type="password" v-model="editedItem.password" :messages="checkIsFree() ? 'Para incluir uma senha faça upgrade' : ''" :disabled="checkIsFree()" />
                <p-btn-upgrade v-if="checkIsFree()"></p-btn-upgrade>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-tooltip top v-if="JSON.stringify(this.beforeEditedItem) === JSON.stringify(this.editedItem)">
            <v-btn slot="activator" class="mx-0" flat color="primary" disabled>Salvar</v-btn>
            <span>Faça alguma alteração para salvar</span>
          </v-tooltip>
          <v-btn class="mx-0" flat color="primary" v-else @click.native="confirm">Salvar</v-btn>
          <v-btn class="mx-0" flat @click.native="cancel">Sair</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
  import plan from './../../mixin/plan'
  import PBtnUpgrade from './PBtnUpgrade'

  export default {
    name: 'PShareTask',
    mixins: [plan],
    components: {PBtnUpgrade},
    props: {
      shared: {
        type: Boolean
      },
      password: {
        type: String
      },
      task_id: {
        type: Number
      }
    },
    data: () => ({
      dialog: false,
      beforeEditedItem: {shared: false, password: ''},
      editedItem: {shared: false, password: ''}
    }),
    // mounted () {
    // },
    methods: {
      openDialog () {
        Object.assign(this.editedItem, {shared: this.shared, password: this.password ? atob(this.password) : ''})
        Object.assign(this.beforeEditedItem, JSON.parse(JSON.stringify(this.editedItem)))
        this.dialog = true
      },
      copy () {
        var copyText = document.getElementById('link')
        /* Select the text field */
        copyText.select()
        /* For mobile devices */
        copyText.setSelectionRange(0, 99999)
        /* Copy the text inside the text field */
        setTimeout(() => {
          document.execCommand('copy')
          this.$store.commit('snackbar/change_values', { text: `Link copiado para sua área de transferência!`, color: 'success', dialog: true })
        }, 200)
      },
      toggleShared () {
        this.$emit('toggleShared')
      },
      confirm () {
        this.$emit('confirm')
        this.$store.commit('loader/change_dialog', true)
        // quando vem null no btoa ele gerava uns caracteres, poratnto foi colocado o ? :
        this.editedItem.password = this.editedItem.password ? btoa(this.editedItem.password) : ''
        this.$http.put('api/tasks/' + this.task_id, this.editedItem).then(
          (res) => {
            this.$emit('input', this.editedItem)
            this.dialog = false
            this.$store.commit('loader/change_dialog', false)
            this.$store.commit('snackbar/change_values', { text: `Compartilhamento salvo com sucesso!`, color: 'success', dialog: true })
            let temp = {old_user_id: res.body.users, users: res.body.users} // Utiliza variavel temporaria "temp" para não precisar alterar valores do val ao adicionar a tarefa.
            Object.assign(temp, res.body)
            delete temp.crud_access
            if (res.body.level === 1) {
              // Atualiza a tela de consulta
              for (let prop in temp.participants) {
                this.$socket.emit('generalEvent', {
                  data: temp,
                  responseEvent: 'editSocketItem',
                  room: `tasks${temp.participants[prop]}`
                })
              }
              // Atualiza a tela de gerenciamento
              this.$socket.emit('generalEvent', {
                data: {values: temp, entity: 'tarefa'},
                responseEvent: 'editSocketManagementDetails',
                room: `tasks${res.body.id}_manage`
              })
            } else {
              for (let user in res.body.participants) {
                this.$socket.emit('generalEvent', {
                  data: temp,
                  responseEvent: 'editSubTask',
                  room: `tasks${res.body.participants[user]}`
                })
              }
              this.$socket.emit('generalEvent', {
                data: {values: temp, entity: 'tarefa'},
                responseEvent: 'editSocketManagementDetails',
                room: `tasks${res.body.id}_manage`
              })
            }
          },
          err => {
            if (err.body.message === 'actionDenied') {
              this.$store.commit('snackbar/change_values', {timeout: 12000, text: 'Apenas os administradores da empresa, responsáveis da equipe ou o responsável da tarefa podem compartilha-la.', color: 'warning', dialog: true})
            } else {
              this.$store.commit('snackbar/change_values', {text: 'Não foi possível editar o registro, reporte o erro.', color: 'error', dialog: true})
              alert('Erro! Falha ao enviar a requisição.')
            }
            this.$emit('err', err)
            this.$store.commit('loader/change_dialog', false)
            this.loading = false
            this.dialog = false
          }
        )
      },
      cancel () {
        this.dialog = false
        this.$emit('cancel')
      }
    },
    computed: {
      link: function () {
        return `https://${window.location.hostname}/#/task_shared/${this.task_id}`
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/shared/PShareTask.vue